import React from 'react';
import { cn } from '@/lib/utils/cn';
import { strobeOnHover } from '@/components/ui/nav-strobe';

interface NavButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  isActive?: boolean;
}

export function NavButton({ children, className, onClick, isActive = false }: NavButtonProps) {
  return (
    <button
      className={cn('nav-button nav-strobe cursor-pointer', isActive && 'nav-strobe-active', className)}
      onClick={onClick}
      {...strobeOnHover}
    >
      {children}
    </button>
  );
}
